import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import './css/NewPred.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faX } from '@fortawesome/free-solid-svg-icons';
import ludA from './images/step1a.png';
import ludB from './images/step1b.png';
import KetcherComp from './KetcherComp.js';
import labService from './labService';

const NewPred = () => {
    const navigate = useNavigate();
    const { analysisPk } = useParams();
    const [analName, setAnalName] = useState("");
    const [smiles, setSmiles] = useState("");
    const [haveSmiles, setHaveSmiles] = useState('dopa');
    const [error, setError] = useState(null);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [validSmiles, setValidSmiles] = useState(true);
    const [analysis, setAnalysis] = useState(null);
    const npContentRef = useRef(null);



    useEffect(() => {
        // Check if analysisPk exists before running the effect
        if (!analysisPk) return;

        const token = JSON.parse(localStorage.getItem('user'))?.access;
        
        if (!token) {
            setError("You must be logged in to view this page.");
            return;
        }

        const fetchAnalIfPk = async () => {
            try {
                const response = await labService.getAnalysisDetail(analysisPk, token);
                console.log(response.data);
                setAnalysis(response.data);
                setSmiles(response.data.smiles)
                setAnalName(response.data.name)

            } catch (error) {
                console.error('Error fetching analysis details:', error);
                setError('Failed to fetch Analysis. Please try again.');
            }
        };
        
        fetchAnalIfPk();
    }, [analysisPk]);


    const handleUpdate = async () => {
        const currentSmiles = await window.ketcher.getSmiles();
        setSmiles(currentSmiles);
    };

    const handleGoBack = () => {
        navigate('/home');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitted(true);
    
        if (!analName || !smiles) {
            // Don't proceed if inputs are empty
            return;
        }
    
        const user = JSON.parse(localStorage.getItem('user'));
        
        if (!user || !user.access) {
            setError("You must be logged in to start a prediction.");
            return;
        }
    
        const token = user.access;

        if (!analysisPk) {

            const endpoint_type = JSON.parse(localStorage.getItem('selectedEndpoint'));
            const selected_models = JSON.parse(localStorage.getItem('selectedModels'));
        
            const data = {
                smiles: smiles,
                name: analName,
                endpoint_type: endpoint_type,
                selected_models: selected_models,
            };
        
            try {
                const response = await labService.startPrediction(data, token);
                if (response && response.data && response.data.redirect_url) {
                    // Navigate to the redirect URL returned by the API
                    navigate(response.data.redirect_url);
                } else {
                    setError("An error occurred while starting the prediction. Please try again.");
                }
                
            } catch (error) {
                if (error.response.data.error === 'Invalid_Smiles') {
                    setValidSmiles(false)
                } else {
                    setError("An error occurred while starting the prediction. Please try again.");
                }
            }

        } else {
            const selected_models = JSON.parse(localStorage.getItem('selectedModels'));
            const data = {
                analysis_pk: analysisPk,
                smiles: smiles,
                name: analName,
                selected_models: selected_models,
            };

            try {
                const response = await labService.startPrediction(data, token);
                if (response && response.data && response.data.redirect_url) {
                    // Navigate to the redirect URL returned by the API
                    navigate(response.data.redirect_url);
                } else {
                    setError("An error occurred while starting the prediction. Please try again.");
                }
                
            } catch (error) {
                if (error.response.data.error === 'Invalid_Smiles') {
                    setValidSmiles(false)
                } else {
                    setError("An error occurred while starting the prediction. Please try again.");
                }
            }
        }
    };

    // const handleDrawSmilesClick = () => {
    //     const npContent = npContentRef.current;
    //     if (npContent) {
    //         const scrollPosition = npContent.scrollTop; // Get the current scroll position
    //         setHaveSmiles('no'); // Update state
    //         // Use setTimeout to wait for state update before restoring scroll position
    //         setTimeout(() => {
    //             npContent.scrollTop = scrollPosition; // Restore scroll position
    //             npContent.scrollTo({
    //                 top: scrollPosition + 50, // Move down by 50px
    //                 behavior: 'smooth', // Smooth scrolling
    //             });
    //         }, 0);
    //     }
    // };
    

    return (
        <div className='new-pred-container'>
            <div className='np-tabs'>
                <div className='x'>
                    <button onClick={handleGoBack} className='x-but'>
                        <FontAwesomeIcon className='icon-x' icon={faX} />
                    </button>
                </div>
                <div className='np-steps done-step'>
                    <p className='p-step'>STEP 1</p>
                    <p>Select Model</p>
                </div>
                <div className='np-steps active-tab'>
                    <p className='p-step'>STEP 2</p>
                    <p>Define Compound</p>
                </div>
                <div className='np-steps'>
                    <p className='p-step'>STEP 3</p>
                    <p>Summary</p>
                </div>
                <div className='np-steps'>
                    <p className='p-step'>STEP 4</p>
                    <p>Results</p>
                </div>
            </div>
            <div className='np-content' ref={npContentRef}>
                <form className='anal-form'>
                    <div className='input-wrap'>
                        <div className='input-cont'>
                            <label className={`${isSubmitted && !analName ? 'error-input' : ''}`} htmlFor="anal-name">Analysis name</label>
                            <input
                                className='input-anal-name'
                                type="text"
                                id="anal-name"
                                value={analName}
                                placeholder='max. 65 characters'
                                onChange={(e) => setAnalName(e.target.value)}
                                required
                            />
                        </div>
                    </div>
                    <div className='anal-error-div'>
                        <p className={`${isSubmitted && !analName ? 'anal-error' : 'anal-error-hide'}`}>Analysis name is required</p>
                    </div>
                    <div className='form-options'>
                        <div className={`form-opt ${haveSmiles === 'yes' ? 'active-opt' : ''}`}
                            onClick={() => setHaveSmiles('yes')}>
                            <div className='lud-smi-div'>
                                <img className="ludzik-smiles" src={ludB} alt="ludzik" />
                            </div>
                            <p>I have SMILES notation for my compound</p>
                        </div>
                        <div className='or'>
                            <p>OR</p>
                        </div>
                        <div className={`form-opt ${haveSmiles === 'no' ? 'active-opt' : ''}`}
                            onClick={() => setHaveSmiles('no')}>
                            <div className='lud-smi-div'>
                                <img className="ludzik-smiles" src={ludA} alt="ludzik" />
                            </div>
                            <p>I don't have SMILES notation for my compound</p>
                        </div>
                    </div>

                    {haveSmiles === 'yes' ? (
                    <div className='one-hun'>
                        <div className='input-wrap'>
                            <div className='input-cont'>
                                <label className={`${isSubmitted && (!smiles || !validSmiles) ? 'error-input' : ''}`} htmlFor="smiles">Compound SMILES notation:</label>
                                <input
                                    className='input-text'
                                    type="text"
                                    id="smiles"
                                    value={smiles}
                                    onChange={(e) => {
                                        const inputValue = e.target.value;
                                        setSmiles(inputValue);
                                        // Reset validSmiles to true if the input is empty
                                        if (inputValue.trim() === "") {
                                            setValidSmiles(true);
                                        }
                                    }}
                                    required
                                />
                            </div>
                            
                        </div>
                        <div className='anal-error-div'>
                            <p className={`${isSubmitted && !validSmiles && smiles ? 'smiles-error' : 'anal-error-hide'}`}>The SMILES notation you have provided could not be translated to molecular structure. Try again.</p>
                        </div>
                    </div>
                        
                    ) : (haveSmiles === 'no' ? (
                        <div className='input-ketcher'>
                            <label className={`label-ketcher ${isSubmitted && (!smiles || !validSmiles) ? 'error-input' : ''}`} htmlFor="smiles">Compound SMILES notation:</label>
                            <div className='input-updater'>
                                <input
                                    className='input-text'
                                    type="text"
                                    id="smiles"
                                    value={smiles}
                                    onChange={(e) => {
                                        const inputValue = e.target.value;
                                        setSmiles(inputValue);
                                        console.log(smiles)
                                        // Reset validSmiles to true if the input is empty
                                        if (inputValue.trim() === "") {
                                            console.log('dopa')
                                            setValidSmiles(true);
                                        }
                                    }}
                                    required
                                />
                                <button type="button" onClick={handleUpdate}>Update</button>
                                
                            </div>
                            <div className='smiles-error-div'>
                                <p className={`${isSubmitted && !validSmiles && smiles ? 'smiles-error' : 'anal-error-hide'}`}>The SMILES notation you have provided could not be translated to molecular structure. Try again.</p>
                            </div>
                            <p className='p-draw-ketch'>Draw a structure and SMILES notation will generate after clicking <span className='bold'>Update button</span></p>
                        </div>
                    ) : null)}  
                </form>

                {haveSmiles === 'yes' ? (
                <div className='center-items'>
                    <button className={`${smiles && analName ? 'save-but-ready' : 'save-but'}`} type="submit" onClick={handleSubmit}>Next</button>
                {error && <p className="error-message">{error}</p>}
                </div>
                ) : (haveSmiles === 'no' ? (
                <div className='center-items'>
                    <div className='div-ketcher'>
                        <div className='ketcher-wrap'>
                            <KetcherComp />
                        </div>
                        <button className={`${smiles && analName ? 'save-but-ready' : 'save-but'}`} type="submit" onClick={handleSubmit}>Next</button>
                        {error && <p className="error-message">{error}</p>}
                    </div>
                </div>
                ) : null)} 
            </div>
        </div>
    );
};

export default NewPred;
